export const toSuffixed = (n: number, singular: string, plural: string, none: string): string => {
  const suffix = n > 1 ? plural : singular;
  return n > 0 ? `${n} ${suffix}` : none;
};
